import { useDispatch, useSelector } from "react-redux"


const useLocale = () => {
    const locale = useSelector((state: any) => state.page.locale);
    const dispatch = useDispatch();

    const setLocale = (locale: string) => {
        dispatch({ type: 'page/setLocale', payload: locale });
    }

    return {
        locale,
        setLocale
    }
}

export default useLocale;